import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Generic confirmation modal (light overlay style).
 * Render it conditionally from the parent; it is a self-contained overlay.
 */
export default function ConfirmModal({
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  busyLabel,
  danger = true,
  loading = false,
  icon: Icon = AlertTriangle,
  onConfirm,
  onClose,
}) {
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div
        className="bg-white border border-shell-card-border rounded-xl p-6 w-full max-w-sm"
        onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-3 mb-3">
          <div
            className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
              danger ? 'bg-[#EF4444]/10' : 'bg-primary/10'
            }`}>
            <Icon className={`w-4 h-4 ${danger ? 'text-[#EF4444]' : 'text-primary'}`} />
          </div>
          <h3 className="text-lg font-semibold text-[var(--text-color)]">{title}</h3>
        </div>
        <div className="text-sm text-muted mb-6 space-y-2">{message}</div>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-muted hover:text-[var(--text-color)]">
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`px-4 py-2 text-sm font-medium rounded-lg disabled:opacity-50 transition-colors ${
              danger ? 'bg-[#EF4444] hover:bg-[#EF4444]/90 text-white' : 'bg-primary hover:bg-primary/90 text-white'
            }`}>
            {loading ? busyLabel || `${confirmLabel}...` : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
